// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BtVq","type":"styles_type__3d-L8","choices":"styles_choices__1omUe"};